import React, { useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "../lib/api";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";

export default function AcceptInvite() {
  const navigate = useNavigate();
  const token = useMemo(() => new URLSearchParams(window.location.search).get("token"), []);
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setErr(""); setBusy(true);
    try {
      await api.post("/auth/accept-invite", { token, password });
      navigate("/login?welcome=1");
    } catch (e2) {
      setErr(e2?.response?.data?.detail || "Invalid or expired invitation");
    }
    setBusy(false);
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-background p-4">
      <form onSubmit={submit} className="w-full max-w-md space-y-4 rounded-2xl border border-border bg-card p-8">
        <h1 className="font-head text-2xl font-bold">Set up your account</h1>
        <p className="text-sm text-muted-foreground">Create your own password — passwords are never emailed.</p>
        {err && <div data-testid="invite-error" className="rounded-xl bg-destructive/10 p-3 text-sm text-destructive">{String(err)}</div>}
        <div className="space-y-2">
          <Label htmlFor="pw">Create password</Label>
          <Input id="pw" data-testid="invite-password" type="password" value={password}
            onChange={(e) => setPassword(e.target.value)} required minLength={8} className="h-11" />
        </div>
        <div className="space-y-2">
          <Label htmlFor="pw2">Confirm password</Label>
          <Input id="pw2" data-testid="invite-password-confirm" type="password" value={confirm} onChange={(e) => setConfirm(e.target.value)} required minLength={8} className="h-11" />
          {confirm && confirm !== password && <p className="text-xs text-destructive" data-testid="invite-password-mismatch">Passwords do not match</p>}
        </div>
        <p className="text-xs text-muted-foreground">Next, you'll sign in and set up Google Authenticator as your second factor.</p>
        <Button type="submit" className="h-11 w-full" disabled={busy || !password || password !== confirm} data-testid="invite-submit">
          {busy ? "Saving…" : "Activate account"}
        </Button>
      </form>
    </div>
  );
}
